import TeamCarousel from 'modules/teamCarousel';
import VideoModal from 'modules/VideoModal';

export default {
	init() {
		TeamCarousel.init($('.js-team-carousel'));
		VideoModal.init($('.js-play-video'), $('#featured-video'));
	},
};
